import { Icon } from '@chakra-ui/react';

export const PeerBold = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M7 16.0059C7 14.349 8.34315 13.0059 10 13.0059H14C15.6569 13.0059 17 14.349 17 16.0059V18.9412C17 18.9742 16.9732 19.001 16.9402 19.001H7.05981C7.02678 19.001 7 18.9742 7 18.9412V16.0059Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M14.2859 7.42648C14.2859 8.76601 13.1991 9.85296 11.8573 9.85296C10.5154 9.85296 9.42871 8.76601 9.42871 7.42648C9.42871 6.08695 10.5154 5 11.8573 5C13.1991 5 14.2859 6.08695 14.2859 7.42648Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M5.30371 11.6846V11.6846C4.03133 11.6846 2.99986 12.7148 2.99986 13.9872C2.99986 15.1065 2.99986 16.4996 2.99986 17.8516C2.99986 18.4854 3.51366 18.999 4.14746 18.999V18.999"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M7 4.5C6.5 4 5.69122 4.1887 5.69122 4.1887C5.38791 4.31433 5.11231 4.49848 4.88016 4.73063C4.64802 4.96278 4.46387 5.23837 4.33823 5.54169C4.21259 5.845 4.14793 6.17009 4.14793 6.49839C4.14793 6.8267 4.21259 7.15179 4.33823 7.4551C4.46387 7.75842 4.64802 8.03402 4.88016 8.26616C5.27751 8.66433 6.5 8.99793 7 8.49905"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M18.6963 11.6846V11.6846C19.9687 11.6846 21.0001 12.7148 21.0001 13.9872C21.0001 15.1065 21.0001 16.4996 21.0001 17.8516C21.0001 18.4854 20.4863 18.999 19.8525 18.999V18.999"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path
      d="M17 4.5C17.5 4 18.3088 4.1887 18.3088 4.1887C18.6121 4.31433 18.8877 4.49848 19.1198 4.73063C19.352 4.96278 19.5361 5.23837 19.6618 5.54169C19.7874 5.845 19.8521 6.17009 19.8521 6.49839C19.8521 6.8267 19.7874 7.15179 19.6618 7.4551C19.5361 7.75842 19.352 8.03402 19.1198 8.26616C18.7225 8.66433 17.5 8.99793 17 8.49905"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
  </Icon>
);
